import { SafeHtml } from '@angular/platform-browser';
import { DevUtils } from 'src/providers/apiservices/Utils';
import { APIService } from 'src/providers/apiservices/apiservices';
import { ComunicacaoContrato } from 'src/providers/comunicacao/comunicacao';
import {
  IdTipoComunicado,
  StatusComunicacao,
} from '../createcomunicado/createcomunicado.page';
import { TarefaDTO } from './message-comunicacao';
import { MESSAGE_STAGE_ENUM } from './message.enum';

export interface IViewMessagesData extends ComunicadoDTO.ComunicacaoTexto {
  message: SafeHtml;
  date: string;
  dataEnvioNotificacao: string;
  arquivos: any[];
}

export interface IViewArquivosData {
  title: string;
  idArquivo: string;
  idGestorDocumentos: string;
  [x: string]: any;
}

export interface IViewUser {
  name: string;
  email: string;
}

export interface IComunicacaoViewData {
  header: string;
  date: string;
  title: string;
  messages: IViewMessagesData[];
  tipoComunicado: IdTipoComunicado;
  arquivos: Array<IViewArquivosData>;
  status: StatusComunicacao;
  contratos: Array<ComunicadoDTO.Contrato>;
  contratosPreview: Array<ComunicadoDTO.Contrato>;
  createdBy: IViewUser;
  approvedBy: IViewUser;
  deadline: string;
  origem: string;
  justificativaRejeicao: string;
  contratosPendentesResposta: Array<ComunicacaoContrato>;
}

type TypeStrComunicacao =
  | 'Comunicação'
  | 'Notificação'
  | 'Solicitação'
  | 'Promoção';

export class MessageController {
  // MESSAGE_STAGE: MESSAGE_STAGE_ENUM = MESSAGE_STAGE_ENUM.VISUALIZACAO;
  public _comunicacao?: ComunicadoDTO.IdComunicacaoNavigation = null;
  public set comunicacao(value: ComunicadoDTO.IdComunicacaoNavigation) {
    if (!value) return;
    this._comunicacao = value;

    let justificativa = {
      texto: '',
      date: null,
    };

    if (this.isReply == false) {
      this._comunicacao.comunicacaoTextos
        .filter((x) => x.idTipoTexto == 2)
        .forEach((x) => {
          if (justificativa.date == null) {
            justificativa.texto = x.texto;
            justificativa.date = new Date(x.dataCriacao).getTime();
          } else if (justificativa.date < new Date(x.dataCriacao).getTime()) {
            justificativa.date = new Date(x.dataCriacao).getTime();
            justificativa.texto = x.texto;
          }
        });
    }

    let _contratos = [];

    if ((this.comunicacao as any).contratosPreview) {
      _contratos = (this.comunicacao as any).contratosPreview.map(
        (contrato) => ({ contrato })
      );
    }

    if (
      Array.isArray(this.comunicacao.comunicacaoContratos) &&
      this.comunicacao.comunicacaoContratos.length > 0
    ) {
      _contratos =
        this.comunicacao.comunicacaoContratos
          ?.map((comunicacaoContrato) => comunicacaoContrato.contrato)
          .filter((x) => x) || [];

        console.log("*** CONTRATOS ***", _contratos);
    }

    var messages = [];
    if (this.preview) {
      messages = Array.isArray(this.comunicacao.comunicacaoTextos)
        ? this.comunicacao.comunicacaoTextos
        : ([] as any[]);
    } else {
      messages = Array.isArray(this.comunicacao.comunicacaoTextos)
        ? this.comunicacao.comunicacaoTextos.filter(
            (txt) => txt.idTipoTexto == 1 && txt.texto
          )
        : ([] as any[]);
    }

    messages = messages.map((message) => {
      return {
        ...message,
        arquivos: this.comunicacao.comunicacaoArquivos.filter(
          (x) => x.idTexto == message.idTexto
        ),
      };
    });

    const arquivos = this.comunicacao.comunicacaoArquivos
      .filter((arq) => {
        if (
          messages.find(
            (msg) => msg.idTipoTexto == 3 && arq.idTexto == msg.idTexto
          )
        ) {
          return false;
        }

        return true;
      })
      .map((arquivo) => {
        return {
          idArquivo: arquivo.idArquivo,
          idGestorDocumentos: arquivo.idArquivoNavigation.idGestorDocumentos,
          title: arquivo.idArquivoNavigation.nomeArquivo,
          ...arquivo
        } as IViewArquivosData;
      });

    this.viewData = {
      date: new Date(this.comunicacao.dataComunicacao).toISOString(),
      header: this.comunicacao.idOrigemNavigation.descricaoOrigem,
      justificativaRejeicao: justificativa.texto,
      messages: messages,
      origem: this.comunicacao.idOrigemNavigation.descricaoOrigem,
      title: this.comunicacao.titulo,
      arquivos: arquivos,
      tipoComunicado: this.comunicacao.idTipoComunicacao,
      status: StatusComunicacao.Analise,
      contratos: _contratos || [],
      contratosPreview: (this.comunicacao as any).contratosPreview || [],
      createdBy: {
        name: this.comunicacao.nomeUsuarioCriacao,
        email: this.comunicacao.loginUsuarioCriacao,
      },
      approvedBy: {
        name: this.comunicacao.nomeAprovador,
        email: this.comunicacao.loginAprovador,
      },
      deadline: this.comunicacao.dataLimiteResposta,
      contratosPendentesResposta:
        this.comunicacao.comunicacaoContratos?.filter(
          (ct) => !['S', 'N'].includes(ct.statusRespostaPromocao)
        ) || [],
    };

    let headerStr = this.comunicacao.idOrigemNavigation.descricaoOrigem;

    function descricaoTipoComunicacao(): TypeStrComunicacao {
      if (!value) return 'Comunicação';

      return ({
        1: 'Comunicação',
        2: 'Notificação',
        3: 'Solicitação',
        4: 'Promoção',
      }[value.idTipoComunicacao] || 'Comunicação') as TypeStrComunicacao;
    }

    if (this.tarefa) {
      if (this.tarefa.taD_DISPLAY_NAME?.includes('Ajustar')) {
        headerStr = `Ajustar ${descricaoTipoComunicacao()}`;
      } else if (this.tarefa.taD_DISPLAY_NAME?.includes('Avaliar')) {
        if (this.tarefa.taD_DISPLAY_NAME.includes('Avaliar Resposta')) {
          headerStr = `Avaliar Resposta ${descricaoTipoComunicacao()}`;
        } else {
          headerStr = `Avaliar ${descricaoTipoComunicacao()}`;
        }
      } else if (this.tarefa.taD_DISPLAY_NAME?.includes('Responder')) {
        headerStr = `Responder ${descricaoTipoComunicacao()}`;
      } else if (
        this.tarefa.taD_DISPLAY_NAME?.includes('Data Limite') &&
        this.tarefa.pT_NAME?.includes('Responder Comunicação')
      ) {
        headerStr = this.tarefa.taD_DISPLAY_NAME;
      }
    } else {
      if (this.isAdjust) {
        headerStr = `Ajustar ${descricaoTipoComunicacao()}`;
      } else {
        headerStr = `Avaliar ${descricaoTipoComunicacao()}`;
      }

      headerStr = descricaoTipoComunicacao();
    }

    this.viewData.header = headerStr;

    // console.log("*** VIEW ***", this.viewData)
    //console.log("*** STAGE ***", this.MESSAGE_STAGE)
  }

  get MESSAGE_STAGE(): MESSAGE_STAGE_ENUM {
    var tipo = MESSAGE_STAGE_ENUM.PREVIEW;
    if (this.preview) {
      tipo = MESSAGE_STAGE_ENUM.PREVIEW;
    }
    if (this.tarefa && this.tarefa.taD_DISPLAY_NAME) {
      if (this.tarefa.taD_DISPLAY_NAME.includes('Ajustar')) {
        tipo = MESSAGE_STAGE_ENUM.AJUSTAR_CRIACAO;
      } else if (this.tarefa.taD_DISPLAY_NAME.includes('Avaliar')) {
        if (this.tarefa.taD_DISPLAY_NAME.includes('Avaliar Resposta')) {
          tipo = MESSAGE_STAGE_ENUM.AVALIAR_RESPOSTA;
        } else {
          tipo = MESSAGE_STAGE_ENUM.AVALIAR_CRIACAO;
        }
      } else if (this.tarefa.taD_DISPLAY_NAME.includes('Responder')) {
        tipo = MESSAGE_STAGE_ENUM.RESPONDER;
      } else if (
        this.tarefa.taD_DISPLAY_NAME.includes('Data Limite') &&
        this.tarefa.pT_NAME?.includes('Responder Comunicação')
      ) {
        if (this.currentUserIsCriador) {
          tipo = MESSAGE_STAGE_ENUM.AJUSTE_DATA_LIMITE_EXCEDIDA_LOJISTA;
        } else if (this.currentUserIsAprovador) {
          tipo = MESSAGE_STAGE_ENUM.AVALIAR_DATA_LIMITE_EXCEDIDA_APROVADOR;
        }
      } else if (this.tarefa.taD_DISPLAY_NAME.includes('Confirmar')) {
        tipo = MESSAGE_STAGE_ENUM.CONFIRMAR_NOTIFICACAO;
      }
    } else {
      tipo = MESSAGE_STAGE_ENUM.VISUALIZACAO;
    }

    return tipo;
  }

  public get comunicacao(): ComunicadoDTO.IdComunicacaoNavigation {
    return this._comunicacao;
  }
  public tarefa?: TarefaDTO = null;
  public stores = [];

  public viewData: IComunicacaoViewData = {
    header: '',
    date: new Date().toISOString(),
    title: '',
    messages: [],
    tipoComunicado: 1,
    arquivos: [],
    status: StatusComunicacao.Analise,
    contratosPreview: [],
    contratos: [],
    createdBy: null,
    approvedBy: null,
    deadline: null,
    origem: null,
    justificativaRejeicao: null,
    contratosPendentesResposta: [],
  };

  /**
   * Valida se é um ajuste.
   */
  public get isAdjust(): boolean {
    return this.tarefa?.taD_DISPLAY_NAME?.includes('Ajustar') || false;
  }

  public get taskContractName(): string {
    if (!this.tarefa) return '';

    let { bdnomE_CONTRATO, bdnumerO_CONTRATO, bdluc } = this.tarefa;

    if(!bdnomE_CONTRATO || !bdnumerO_CONTRATO)
        return "";

    return `${DevUtils.urlDecode(bdnomE_CONTRATO).replace(
      '+',
      ' '
    )} \n (${bdnumerO_CONTRATO}) - ${bdluc}`;
  }

  public get taskContractNumber(): string {
    return this.tarefa?.bdnumerO_CONTRATO || '';
  }

  /**
   * É uma avaliação de resposta/data limite para resposta foi excedida.
   */
  public get isRateReply(): boolean {
    return this.tarefa?.name?.includes('Avaliar Resposta');
  }

  public get isReply(): boolean {
    if (this.tarefa) {
      return !!this.tarefa.taD_DISPLAY_NAME?.includes('Responder');
    } else {
      return false;
    }
  }

  public get canEdit(): boolean {
    if (this.limitDateExceeded == true || this.isReply == true) return false;

    if (this.tarefa) {
      return (
        this.tarefa.taD_DISPLAY_NAME?.includes('Avaliar') ||
        this.tarefa.taD_DISPLAY_NAME?.includes('Ajustar') ||
        false
      );
    } else {
      return false;
    }
  }
  public get isTarefa(): boolean {
    return this.tarefa != null;
  }

  public get limitDateExceeded(): boolean {
    if (!this.comunicacao?.dataLimiteResposta) return false;

    const stagesComDataLimiteExcedida = [
      MESSAGE_STAGE_ENUM.AJUSTE_DATA_LIMITE_EXCEDIDA_CRIADOR,
      MESSAGE_STAGE_ENUM.AJUSTE_DATA_LIMITE_EXCEDIDA_LOJISTA,
      MESSAGE_STAGE_ENUM.AVALIAR_DATA_LIMITE_EXCEDIDA_APROVADOR
    ];
    
    if (stagesComDataLimiteExcedida.includes(this.MESSAGE_STAGE)) {
      return true;
    }

    return new Date(this.comunicacao.dataLimiteResposta) < new Date();
  }

  public currentUserIsAprovador: boolean = false;

  public currentUserIsCriador: boolean = false;

  /**
   * @example
   * 1 -> Comunicado
   * 2 -> Notificação
   * 3 -> Solicitação
   * 4 -> Promoção
   */
  public get tipoComunicacao(): IdTipoComunicado {
    return this.comunicacao?.idTipoComunicacao;
  }

  public get isComunicacao(): boolean {
    return this.tipoComunicacao == IdTipoComunicado.Comunicado;
  }

  public get isNotificacao(): boolean {
    return this.tipoComunicacao == IdTipoComunicado.Notificação;
  }

  public get isPromocao(): boolean {
    return this.tipoComunicacao == IdTipoComunicado.Promoção;
  }

  public get isSolicitacao(): boolean {
    return this.tipoComunicacao == IdTipoComunicado.Solicitação;
  }

  private preview: boolean = false;

  constructor(params?: {
    comunicacao;
    tarefa;
    idComunicacao;
    loadingController;
    stores;
    preview;
    view;
  }) {
    Object.assign(this, params);

    if (
      this.comunicacao &&
      Array.isArray(this.comunicacao.comunicacaoContratos)
    ) {
      const user = localStorage.getItem('uc' + APIService.storage_key + APIService.UsuarioLogado.Usuario.login1);

      if (user) {
        try {
          let userObj = JSON.parse(user);

          this.currentUserIsAprovador =
            userObj.usuario == this.comunicacao.loginAprovador;
          this.currentUserIsCriador =
            userObj.usuario == this.comunicacao.loginUsuarioCriacao;
        } catch (error) {
          console.error(error);
          this.currentUserIsAprovador = false;
          this.currentUserIsCriador = false;
        }
      }

      this.comunicacao = {
        ...this.comunicacao,
        comunicacaoContratos: this.comunicacao.comunicacaoContratos.map(
          (CommContrato) => {
            const store = this.stores.find(
              (x) => x.numContrato == CommContrato.numContrato
            );

            CommContrato.contrato = store;

            return CommContrato;
          }
        ),
      };
    }
  }

  get lojasNaoComunicadas() {
    return this.stores.filter(
      (store) =>
        !this.viewData.contratos.find(
          (loja) => loja.numContrato == store.numContrato
        )
    );
  }

  /**
   * @example
   * 1 -> Comunicação
   * 2 -> Notificação
   * 3 -> Solicitação
   * 4 -> Promoção
   */
  get descricaoTipoComunicacao(): TypeStrComunicacao {
    if (!this.comunicacao) return 'Comunicação';

    return ({
      1: 'Comunicação',
      2: 'Notificação',
      3: 'Solicitação',
      4: 'Promoção',
    }[this.comunicacao.idTipoComunicacao] ||
      'Comunicação') as TypeStrComunicacao;
  }
}
